import i18n from ".";

const SERVER_TERMS = ["Production (Ex-Pit)", "In Pit", "Rehandle", "Crushing", "Ore", "Waste", "Total Ex-Pit Movement", "Total In-Pit Movement", "Total Material Movement", "Tonnes", "Blastmaster", "Blast Pattern"] as const;

const isServerTerm = (value: string): value is (typeof SERVER_TERMS)[number] => (SERVER_TERMS as readonly string[]).includes(value);

// Note: these are fixed English words the API builds into its responses, matched exactly; anything else, such as a
// location name, is the mine's own data and passes through untranslated.
export const serverTerm = <T extends string | null | undefined>(value: T): T | string =>
  value && isServerTerm(value) ? i18n.t(`serverTerms.${value}`) : value;
